import React from "react";

// Helper components for consistent styling
export const KeyTerm = ({ term, definition }: { term: string; definition: string }) => (
  <div className="bg-slate-50 p-4 rounded-lg border border-slate-100 mb-3">
    <h4 className="font-semibold text-slate-900">{term}</h4>
    <p className="text-sm text-slate-600 mt-1">{definition}</p>
  </div>
);

export const NeurotransmitterCard = ({ name, functions, issues }: { name: string; functions: string; issues?: string }) => (
  <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-lg border border-blue-100 mb-3">
    <h4 className="font-bold text-blue-900">{name}</h4>
    <p className="text-sm text-slate-700 mt-1"><strong>Functions:</strong> {functions}</p>
    {issues && <p className="text-sm text-red-700 mt-1"><strong>Malfunctions:</strong> {issues}</p>}
  </div>
);

export const BrainRegionCard = ({ name, functions }: { name: string; functions: string }) => (
  <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-4 rounded-lg border border-purple-100 mb-3">
    <h4 className="font-bold text-purple-900">{name}</h4>
    <p className="text-sm text-slate-700 mt-1">{functions}</p>
  </div>
);

export const ImportantNote = ({ children }: { children: React.ReactNode }) => (
  <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg my-4">
    <p className="text-amber-800 text-sm font-medium">{children}</p>
  </div>
);

export const Mnemonic = ({ title, content }: { title: string; content: string }) => (
  <div className="bg-green-50 border border-green-200 p-4 rounded-lg my-4">
    <p className="text-green-800 text-sm"><strong>🧠 Mnemonic - {title}:</strong> {content}</p>
  </div>
);
